module.exports = __webpack_public_path__ + "static/media/ball-sharp-line.317f2a36.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/highDefinitionOptics/ball-sharp-line.png
// module id = 3595
// module chunks = 0